import type { Solid, Pattern } from '@web-stories-wp/patterns';

function getOpacityFromPattern(preset: Solid | Pattern): number {
  const { color, alpha, stops } = preset;

  if (color) {
    return color.a ?? 1;
  }

  if (typeof alpha === 'number') {
    return alpha;
  }

  let highestOpacity = 0;

  for (const colorStop of stops || []) {
    if (!colorStop.color.a && colorStop.color.a !== 0) {
      highestOpacity = 1;
      break;
    }

    if (colorStop.color.a > highestOpacity) {
      highestOpacity = colorStop.color.a;
    }
  }

  return highestOpacity;
}

export default getOpacityFromPattern;
